import React from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';

import { TextField } from 'material-ui';

const MaterialUiSearchBox = ({ currentRefinement, refine }) => (
  <div
    style={{
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      padding: '0px 10px',
      marginLeft: 0,
      flexGrow: 1,
    }}
  >
    <TextField
      value={currentRefinement}
      onChange={e => refine(e.target.value)}
      id="SearchBox"
      hintText="Search for a BANNER..."
      fullWidth={true}
      underlineShow={false}
    />
  </div>
);

const ConnectedSearchBox = connectSearchBox(MaterialUiSearchBox);
export default ConnectedSearchBox;



// WEBPACK FOOTER //
// ./src/components/Algolia/ConnectedSearchBox.js